import type { AdminEmployeePointsCalculation } from "../modules/types";
import { adminApiGet } from "./utils";

export const adminEmployeePointsCalculationsApi = {
  getAll: (workspaceId?: string): Promise<AdminEmployeePointsCalculation[]> =>
    adminApiGet<AdminEmployeePointsCalculation[]>(
      workspaceId
        ? `/employee_points_calculations?workspace_id=${encodeURIComponent(workspaceId)}`
        : "/employee_points_calculations",
    ),

  getById: (id: string): Promise<AdminEmployeePointsCalculation> =>
    adminApiGet<AdminEmployeePointsCalculation>(
      `/employee_points_calculations/${id}`,
    ),
};
